import Carousel from "react-elastic-carousel";
import { useRef, useState } from "react";
import ProductsData from "./productsData";

import "./style.scss";
import { Link, useOutletContext } from "react-router-dom";

const Products = () => {
  const [productIndex, setProductIndex] = useOutletContext();

  const carouselRef = useRef(null);
  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 1, itemsToScroll: 1 },
    { width: 768, itemsToShow: 2, itemsToScroll: 1 },
    { width: 1200, itemsToShow: 2, itemsToScroll: 1 },
  ];

  const handleClickProduct = (index) => {
    setProductIndex(index);
  };

  return (
    <div>
      <Carousel
        ref={carouselRef}
        breakPoints={breakPoints}
        showArrows={true}
        pagination={false}
        enableAutoPlay={false}
        autoPlaySpeed={3000}
        initialActiveIndex={productIndex}
      >
        {ProductsData.map((product, index) => (
          <div key={index} className="product-img-container m-1 w-100">
            <img src={product.image} alt="product" />

            <Link
              to={`/products/${product.key}`}
              className="text-decoration-none text-reset"
              onClick={() => handleClickProduct(index)}
            >
              <div className="product-text-centered d-flex justify-content-center flex-column gap-2">
                <p>{product.title}</p>
                <span className="read-more-text"> Read More</span>
              </div>
            </Link>
          </div>
        ))}
      </Carousel>
    </div>
  );
};
export default Products;
